import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6585fc2c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_conts"
};
const _hoisted_2 = {
  class: "tab_boxs"
};
const _hoisted_3 = {
  class: "table_boxs"
};
const _hoisted_4 = {
  key: 1,
  style: {
    "width": "40px",
    "height": "40px"
  }
};
const _hoisted_5 = {
  class: "status"
};
const _hoisted_6 = {
  class: "desc"
};
import { reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import RemakeDialog from "./components/remake-dialog.vue";
import { getuserListApi, editUserRemarkApi } from "@/service/modules/user";
export default /*#__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const formdata = reactive({
      mobile: "",
      openid: ""
    });
    function handleLogList(type = "") {
      if (type === "rest") {
        formdata.mobile = "";
        formdata.openid = "";
      }
      get_list();
    }
    const loading = ref(false);
    //tabs
    const tablist = ref([{
      label: "全部",
      name: "0"
    }, {
      label: "今日新增",
      name: "1"
    }, {
      label: "昨日新增",
      name: "2"
    }, {
      label: "近7天",
      name: "3"
    }, {
      label: "近30天",
      name: "4"
    }]);
    const tabsActive = ref("0");
    const data_list = ref([]);
    let page = ref({
      page: 1,
      pageSize: 15
    });
    const total = ref(20);
    let date_ = ref({
      start_time: "",
      end_time: ""
    });
    async function get_list() {
      loading.value = true;
      let reqdata = {
        page: page.value.page,
        pageSize: page.value.pageSize,
        mobile: formdata.mobile,
        openid: formdata.openid,
        start_time: date_.value.start_time,
        end_time: date_.value.end_time
      };
      const res = await getuserListApi(reqdata);
      data_list.value = res.data.data;
      total.value = res.data.total;
      loading.value = false;
    }
    get_list();
    const remakeDialogVisible = ref(false);
    function closeRoleDialog() {
      remakeDialogVisible.value = false;
    }
    const remakeDialogData = ref({});
    function handleRoleDialog(row) {
      remakeDialogData.value = row;
      remakeDialogVisible.value = true;
    }
    async function handle_status(row) {
      let reqdata = {
        id: row.id,
        status: row.status == 1 ? 0 : 1
      };
      const res = await editUserRemarkApi(reqdata);
      if (res.code == 0) {
        get_list();
      }
    }
    function doHandleMonth(month) {
      var month = month;
      if (month.toString().length == 1) {
        var month = "0" + month;
      }
      return month;
    }
    function restData() {
      closeRoleDialog();
      get_list();
    }
    //获取时间，传入  1234.分别是    今日，昨日，近7天，近30天
    function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); // 注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = doHandleMonth(tMonth + 1);
      tDate = doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    }
    //监听
    watch(() => tabsActive.value, val => {
      page.value = {
        page: 1,
        pageSize: 15
      };
      if (val === "1") {
        date_.value.start_time = getDay(0);
        date_.value.end_time = getDay(0);
      } else if (val === "2") {
        date_.value.start_time = getDay(-1);
        date_.value.end_time = getDay(-1);
      } else if (val === "3") {
        date_.value.start_time = getDay(-7);
        date_.value.end_time = getDay(0);
      } else if (val === "4") {
        date_.value.start_time = getDay(-30);
        date_.value.end_time = getDay(0);
      } else {
        date_.value.start_time = "";
        date_.value.end_time = "";
      }
      console.log(getDay(1));
      get_list();
    });
    return (_ctx, _cache) => {
      const _component_top_title = _resolveComponent("top-title");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_top_title, {
        message: "客户列表"
      }), _createElementVNode("view", _hoisted_1, [_createVNode(_component_el_form, {
        class: "padding-24",
        model: formdata,
        "label-width": "auto",
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "手机号码"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formdata.mobile,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formdata.mobile = $event),
            placeholder: "请输入手机号码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "OpenId"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formdata.openid,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formdata.openid = $event),
            placeholder: "请输入openId"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = $event => handleLogList())
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = $event => handleLogList('rest'))
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
        modelValue: tabsActive.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => tabsActive.value = $event),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablist.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            name: item.name,
            label: item.label
          }, null, 8, ["name", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data_list.value,
        height: "520",
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "用户ID"
        }), _createVNode(_component_el_table_column, {
          prop: "openid",
          label: "OpenID"
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "头像"
        }, {
          default: _withCtx(scope => [scope.row.img ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            style: {
              "width": "40px",
              "height": "40px",
              "border-radius": "50%"
            },
            src: scope.row.img,
            "zoom-rate": 1.2,
            "max-scale": 7,
            "min-scale": 0.2,
            "preview-src-list": [scope.row.img],
            "preview-teleported": true,
            fit: "cover"
          }, null, 8, ["src", "preview-src-list"])) : (_openBlock(), _createElementBlock("div", _hoisted_4))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号"
        }), _createVNode(_component_el_table_column, {
          prop: "auth_page",
          label: "首次授权页面"
        }), _createVNode(_component_el_table_column, {
          prop: "last_time",
          label: "最近访问时间"
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "首次登录时间"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_5, _toDisplayString(scope.row.status == 1 ? "正常" : "封禁"), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "desc",
          width: "250",
          label: "备注信息"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_6, _toDisplayString(scope.row.desc), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleRoleDialog(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("添加")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "",
            type: "danger",
            onClick: $event => handle_status(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status == 1 ? "封禁" : "启用"), 1)]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_proto_pagination, {
        page: _unref(page),
        total: total.value,
        onCurrentChange: get_list
      }, null, 8, ["page", "total"])])]), remakeDialogVisible.value ? (_openBlock(), _createBlock(RemakeDialog, {
        key: 0,
        "dialog-visible": remakeDialogVisible.value,
        "item-data": remakeDialogData.value,
        onCloseDialog: closeRoleDialog,
        onRestData: restData
      }, null, 8, ["dialog-visible", "item-data"])) : _createCommentVNode("", true)]);
    };
  }
});